import "bootstrap/dist/css/bootstrap.css";
import "react-datepicker/dist/react-datepicker.css";
import "./style/styles.css";
import "toastr/build/toastr.css";
import "./style/fontawesome-free-5.15.4-web/css/all.css";

import {
  createRoot,
} from "react-dom/client";
import {
  Provider,
} from "react-redux";
import {
  ReduxRouter,
} from "App/legacy/lagunovskyReduxReactRouter";
import {
  renderChildren,
} from "CommonCore/router-util";
import "CommonComponents/chartjs-plugins";
import "CommonCore/l10n";
import {
  history,
  store,
} from "CommonState/store";
import {
  routes,
} from "App/routes";
import _ from "lodash";

const routerSelector = state => state.router;

const mainRoutes = renderChildren({ childRoutes: routes, match: { path: "" } });
const rootContent =
  <Provider store={store}>

    <ReduxRouter history={history} routerSelector={routerSelector}>
      {mainRoutes}
    </ReduxRouter>

  </Provider>;

window.__REACT_DEVTOOLS_USER_MAPPERS__ = {
  mapState: state => _.omit(state, ["storeState"]),
  mapProps: props => {
    const functions = _.pickBy(props, _.isFunction);
    const regulars = _.omit(
      _.omitBy(props, _.isFunction),
      ["router", "history", "location", "route", "routeParams", "routes"],
    );
    return _.assign(
      _.mapValues(regulars, (v, k) => {
        const state = store.getState();
        return k in state ? "from Redux" : v;
      }),
      _.size(functions) > 0 ? { functions_: functions } : void 0,
    );
  },
  mapContext: context => context,
};

const container = document.getElementById("react-root");
const newRoot = createRoot(container);
newRoot.render(rootContent);
